import React from 'react'
import ActionButton from '../../../../library/input/buttons/button/SarasButton'
import SarasTrans from '../../../../library/notifications/SarasTrans';
import * as fn from "../../../../helper/uiFunctions";

const DocEditChoice = (props) => {
    const { formObject, viewData, rowID, reloadSearch } = props;

    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");
    const isRO = formObject.getValueFromKey(viewData, "dataList.isRO", "");
    const actionId = formObject.getValueFromKey(viewData, "dataList.actionId", "");
    const catId = formObject.getValueFromKey(viewData, "dataList.valLCat", "");
    const choiceId = formObject.getValueFromKey(viewData, "val", "0");

    const onPopupClose = () => {
        if(reloadSearch)reloadSearch();
    }

    const onEditClick = (e) => {
        let customAction = { actionId: actionId, skipMasterKey: 1, containerKey: "popup" };

        customAction.onModalClose = onPopupClose;
        customAction["actionParam"] = { "ctgId": catId, rowId: choiceId };
        customAction["actionName"] = formObject.getValueFromKey(viewData, "dataList.actionName", "");

        if (customAction.actionId) formObject.onFormAction(customAction, rowID, "");
    }

    const renderAction = () => {
        // console.log("is isRO", isRO)
        if(!isRO || fn.compareNumber(isRO, 0))
        {
            return (
                <ActionButton onClick={onEditClick} 
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiLink uiIcon"
                    className={''} />
            )
        }

        return (
            <span><SarasTrans value = "Readonly"/></span>
        );
    }

    return (
        <div className="saras-cell">
            <div className={valCssClass}>
                <span className="uiSpacerR2 ">{viewData.valF}</span>
                {renderAction()}
            </div>
        </div>
    )
}

export default DocEditChoice